import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  thumbInnerDot: {
    borderRadius: "50%",
  },
}));
